var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUiLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "UI-logo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 24,
    viewBox: "0 0 65 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M577.994,0h-2.089a.712.712,0,0,0-.823.822V22.8a.711.711,0,0,0,.823.823h2.089a.711.711,0,0,0,.822-.823V.823A.71.71,0,0,0,577.994,0Z",
    transform: "translate(-554.053 -0.001)",
    fill: "#3743aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M775.15,6.516h0a8.406,8.406,0,0,0-4.985,1.645V.823A.71.71,0,0,0,769.343,0h-2.09a.71.71,0,0,0-.822.822V22.8a.71.71,0,0,0,.822.823h1.958a.711.711,0,0,0,.824-.823v-.559a8.887,8.887,0,0,0,5.116,1.645,8.367,8.367,0,0,0,6.137-2.55,8.364,8.364,0,0,0,2.551-6.136,8.363,8.363,0,0,0-2.551-6.137A8.375,8.375,0,0,0,775.15,6.516Zm3.538,12.224a4.986,4.986,0,0,1-8.523-3.536,4.945,4.945,0,0,1,4.935-4.985,4.944,4.944,0,0,1,5.035,4.985A4.776,4.776,0,0,1,778.688,18.74Z",
    transform: "translate(-738.405 -0.001)",
    fill: "#3743aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M1316.855,180.694a8.268,8.268,0,0,0-6.054-2.534h0a8.5,8.5,0,0,0-6.284,2.551,8.7,8.7,0,1,0,12.339-.016Zm-2.631,9.673h0a4.988,4.988,0,1,1,1.463-3.537A4.769,4.769,0,0,1,1314.224,190.368Z",
    transform: "translate(-1254.391 -171.645)",
    fill: "#3743aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M17.387,186.673v0h0a8.322,8.322,0,0,0-2.531-5.985,9.4,9.4,0,0,0-1.2-1.018A8.17,8.17,0,0,0,8.8,178.15,8.5,8.5,0,0,0,2.517,180.7a8.7,8.7,0,0,0,.033,12.274,8.362,8.362,0,0,0,6.168,2.55A8.33,8.33,0,0,0,13.654,194h0v.437a.713.713,0,0,0,.825.823h2.089a.71.71,0,0,0,.821-.823V186.8a1.117,1.117,0,0,0,0-.131Zm-5.163,3.686a4.765,4.765,0,0,1-3.5,1.432,4.75,4.75,0,0,1-3.488-1.432A4.8,4.8,0,0,1,3.769,186.8a4.73,4.73,0,0,1,1.43-3.471,4.759,4.759,0,0,1,3.488-1.448,4.822,4.822,0,0,1,3.572,1.448,4.753,4.753,0,0,1,1.4,2.912c.011.091.018.183.022.276a.071.071,0,0,0,0,.008v0c.008.1.008.191.008.288a5.208,5.208,0,0,1-.031.585v.016A4.732,4.732,0,0,1,12.224,190.358Z",
    transform: "translate(0 -171.636)",
    fill: "#3743aa"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiLogo);
export default __webpack_public_path__ + "static/media/UI-logo.3d36ee3fd1cec7525074f3a9035c21fb.svg";
export { ForwardRef as ReactComponent };